import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  title: () => __(translations.createStockLocationCategoryModal.title, 'Create stock location category'),
  name: () => __(translations.createStockLocationCategoryModal.name, 'Name'),
};
